export const enum CProvidersMutationsNames {
    SetList = "setContentProviders",
    SetSelected = "setSelectedContentProvider",
    SetError = "contentProvidersError",
    ResetState = "resetState",
}

export const enum CProvidersActionsNames {
    FetchList = "fetchContentProviders",
    SetSelected = "setSelectedContentProvider",
    ResetState = "resetContentProviderState",
}

export const enum CProvidersGettersNames {
    List = "serviceProvidersList",
    Selected = "selectedContentProvider",
    IsSelected = "isSelectedContentProvider",
}
